import { initializeLoginForms } from './loginFormHandler';

$(function () {
    initializeLoginForms();
});